/*
 * delivery-estimate.js — 배송 추정 [계산 계층]
 * ---------------------------------------------------------------------------
 * 영업일/달력일 계산과 공휴일(Nager.Date API) 조회를 담당한다. 배송 범위({min,max}
 * 달력 배송일)를 받아 도착일 창(Date min~max)을 계산한다. UI/데이터와 독립.
 *
 * arrival(range, ctx) → { min:Date, max:Date }
 *   ctx = { cutoffHour, prepDays, holidays, manualHolidays }
 */
window.WookieDelivery = window.WookieDelivery || {};
(function (NS) {
  'use strict';

  var holidayCache = {};

  async function fetchHolidays(countryCode, year) {
    var cacheKey = countryCode + '_' + year;
    if (holidayCache[cacheKey]) return holidayCache[cacheKey];
    try {
      var res = await fetch('https://date.nager.at/api/v3/PublicHolidays/' + year + '/' + countryCode);
      if (!res.ok) return [];
      var data = await res.json();
      var hs = data.map(function (h) { return h.date; });
      holidayCache[cacheKey] = hs;
      return hs;
    } catch (e) {
      return [];
    }
  }

  // 출고국 공휴일(올해+내년) + 수동 휴일 합집합
  async function relevantHolidays(originCode, manualHolidays) {
    var now = new Date();
    var y = now.getFullYear();
    var a = await fetchHolidays(originCode, y);
    var b = await fetchHolidays(originCode, y + 1);
    return Array.from(new Set((manualHolidays || []).concat(a, b)));
  }

  // 영업일 더하기(주말+휴일 건너뜀) — 처리기간용
  function addBusinessDays(date, days, holidays) {
    var d = new Date(date.getTime());
    var remaining = Math.ceil(days);
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      var s = d.toISOString().slice(0, 10);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && holidays.indexOf(s) === -1) remaining--;
    }
    return d;
  }

  // 주말/휴일이면 다음 영업일로 보정
  function adjustToNextBusinessDay(date, holidays) {
    var d = new Date(date.getTime());
    while (true) {
      var s = d.toISOString().slice(0, 10);
      var w = d.getDay();
      if (w !== 0 && w !== 6 && holidays.indexOf(s) === -1) return d;
      d.setDate(d.getDate() + 1);
    }
  }

  // 달력일 더하기(주말 포함) — 운송기간용. 주요 휴일만 건너뜀
  function addCalendarDays(date, days, majorHolidays) {
    var d = new Date(date.getTime());
    var remaining = Math.ceil(days);
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      var s = d.toISOString().slice(0, 10);
      if (majorHolidays.indexOf(s) === -1) remaining--;
    }
    return d;
  }

  // 도착일 창 계산: base(+cutoff) → 처리(영업일) → 운송(달력일) → 영업일 보정
  function arrival(range, ctx) {
    var now = new Date();
    var base = new Date(now);
    if (now.getHours() >= ctx.cutoffHour) base.setDate(base.getDate() + 1);
    var ship = addBusinessDays(base, ctx.prepDays, ctx.holidays);
    var min = adjustToNextBusinessDay(addCalendarDays(ship, range.min, ctx.manualHolidays), ctx.holidays);
    var max = adjustToNextBusinessDay(addCalendarDays(ship, range.max, ctx.manualHolidays), ctx.holidays);
    return { min: min, max: max };
  }

  NS.Estimate = {
    relevantHolidays: relevantHolidays,
    arrival: arrival,
    addBusinessDays: addBusinessDays,
    addCalendarDays: addCalendarDays,
    adjustToNextBusinessDay: adjustToNextBusinessDay
  };
})(window.WookieDelivery);
